(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

  const days3000 = 3000 * 24 * 60 * 60 * 1000;

  const closedTime = localStorage.getItem('newsletter_closed');
  const submitted = localStorage.getItem('newsletter_submitted');

  const overlay = $('#newsletter-overlay');
  const discountOverlay = $('#discount-overlay');

  const floatBox = $('#newsletter-float');
  const dismissBtn = $('#newsletter-dismiss');


  const closeBtn = $('.newsletter-close');
  const discountClose = $('.discount-close');

  /* STORAGE FUNCTIONS */

  function setPopupClosed() {
    localStorage.setItem('newsletter_closed', Date.now());
  }

  function setNewsletterSubmitted() {
    localStorage.setItem('newsletter_submitted', true);
  }

  /* ==============================
     AUTO POPUP LOGIC
  ============================== */

  if (!submitted) {

    if (!closedTime || (Date.now() - closedTime) > days3000) {
      setTimeout(function(){
        overlay.css('display', 'flex');
      },7000);
    }

    // show floating button only if NOT submitted
    $('#newsletter-float').show();
  }

  floatBox.on('click', function () {
    overlay.css('display', 'flex');
  });

  dismissBtn.on('click', function (e) {
    e.stopPropagation(); // prevent opening popup
    floatBox.hide();
    setPopupClosed();
  });

  /* CLOSE POPUP */

  closeBtn.on('click', function () {
    overlay.hide();
    setPopupClosed();
  });

  /* DISCOUNT CLOSE */

  discountClose.on('click', function () {
    discountOverlay.hide();
  });

  /* CLICK OUTSIDE */

  overlay.on('click', function (e) {
    if (e.target === this) {
      overlay.hide();
      setPopupClosed();
    }
  });

  /* ==============================
     FORM SUBMIT
  ============================== */

  $('body').on('click', '.submit_btn', function (e) {

    e.preventDefault();
    $(this).addClass('loading');
    $(this).find('.loading-overlay__spinner').removeClass('hidden');
    let form = $(this).closest('form');
    let errorDiv = form.find('.errors_div');

    errorDiv.empty();

    let firstName = form.find('[name="contact[first_name]"]').val().trim();
    let lastName = form.find('[name="contact[last_name]"]').val().trim();
    let email = form.find('[name="contact[email]"]').val().trim();

    let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let errors = [];

    if (firstName === '') {
      errors.push('Please enter your first name.');
    }

    if (lastName === '' && errors.length == 0) {
      errors.push('Please enter your last name.');
    }

    if (email === '' && errors.length == 0) {
      errors.push('Please enter your email.');
    } else if (!emailPattern.test(email) && errors.length == 0) {
      errors.push('Please enter a valid email address.');
    }

    if (errors.length > 0) {
      errors.forEach(function (err) {
        errorDiv.append('<p class="error">' + err + '</p>');
      });
      $(this).removeClass('loading');
      $(this).find('.loading-overlay__spinner').addClass('hidden');
      return;
    }

    /* SUCCESS */

    /* AJAX */
		const formData = new FormData(form[0]);

		$.ajax({
			url: form.attr('action'),
			method: 'POST',
			data: formData,
			processData: false,
			contentType: false,
			success: function () {
				overlay.hide();
				discountOverlay.css('display', 'flex');
        setNewsletterSubmitted(); // IMPORTANT
        $('#newsletter-float').hide();
			},
			error: function () {
				errorDiv.append('<p class="error">Something went wrong. Please try again.</p>');
        $(this).removeClass('loading');
        $(this).find('.loading-overlay__spinner').addClass('hidden');
			}
		});

  

  });

  /* COPY CODE */

  $('body').on('click', '.discount-code-wrapper', function () {

    const code = $(this).find('.discount-code-text').text();
    const icon = $(this).find('.copy-icon');

    navigator.clipboard.writeText(code);

    const originalIcon = icon.html();

    icon.html('✓');

    setTimeout(function () {
      icon.html(originalIcon);
    }, 2000);

  });

});

  } catch(e) { console.error(e); }
})();
})();
